export default "__VITE_ASSET__797ed3e4__"